import { useState } from "react";
import { faqs } from "@/mocks/home";

export default function Faq() {
  const [openId, setOpenId] = useState<string | null>(faqs[0].id);

  return (
    <section id="faq" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full max-w-[1180px] mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-4">
            <p className="text-xs tracking-[0.2em] text-primary-700 uppercase">FAQ</p>
            <h4 className="mt-2 font-heading text-2xl md:text-3xl text-foreground-950">
              <a href="#faq" className="cursor-pointer hover:text-primary-700 transition-colors">
                常见问题
              </a>
            </h4>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              关于进不去、镜像差异、更新频率这些高频疑问，都整理在这里了。
            </p>
            <div className="mt-6 rounded-lg border border-background-200 bg-background-50 p-5">
              <i className="ri-customer-service-2-line text-2xl text-primary-600"></i>
              <p className="mt-2 text-[13px] text-foreground-600 leading-relaxed">
                还有没覆盖到的问题？先按「防走失指引」操作，绝大多数情况都能自己解决。
              </p>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
              {faqs.map((f, idx) => {
                const isOpen = openId === f.id;
                return (
                  <div key={f.id} className={idx !== 0 ? "border-t border-background-200" : ""}>
                    <button
                      type="button"
                      onClick={() => setOpenId(isOpen ? null : f.id)}
                      className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
                    >
                      <span className="text-[15px] font-medium text-foreground-950">{f.question}</span>
                      <i
                        className={`shrink-0 text-lg transition-transform ${
                          isOpen ? "ri-subtract-line text-primary-600 rotate-180" : "ri-add-line text-foreground-400"
                        }`}
                      ></i>
                    </button>
                    {isOpen && (
                      <div className="px-5 pb-5 -mt-1">
                        <p className="text-[13px] text-foreground-600 leading-relaxed">{f.answer}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}